import { PublicCertificateNavigator } from '@certificate/certificate-navigator';
import { useParams } from '@certificate/router';

export default function UnofficialPage() {
  const { examEventExamineeId } = useParams(
    '/exam-event-examinees/:examEventExamineeId/unofficial',
  );

  return <PublicCertificateNavigator examEventExamineeId={examEventExamineeId} type='unofficial' />;
}
